import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';

const DevelopmentImpact: FC = () => {
  return <Outlet />;
};

export default DevelopmentImpact;
